var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDefaultThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.7273L10 10",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.0004L17.6364 5.63672",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36328 5.63672L9.99964 10.0004",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49982 1.16314C9.80922 0.984504 10.1904 0.984503 10.4998 1.16314L17.4026 5.14847C17.712 5.3271 17.9026 5.65723 17.9026 6.01449V13.9852C17.9026 14.3424 17.712 14.6725 17.4026 14.8512L10.4998 18.8365C10.1904 19.0151 9.80922 19.0151 9.49982 18.8365L2.59703 14.8512C2.28763 14.6725 2.09703 14.3424 2.09703 13.9852V6.01449C2.09703 5.65723 2.28763 5.3271 2.59703 5.14847L9.49982 1.16314Z",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultThumbnail);
export default __webpack_public_path__ + "static/media/ic_default_thumbnail.3a0759e136bca96d183788557b91f9e6.svg";
export { ForwardRef as ReactComponent };